import styled from "styled-components";

export const Container = styled.div`
  padding: 10px 0px;
  padding-right: 35px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px;

  .container-view {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    button {
      box-sizing: border-box;
    }
  }

  .wishlist-button {
    position: relative;
    z-index: 1;
  }
  .container-view {
    display: flex;
    align-items: center;
    position: relative;
  }

  .wishlist-container {
    position: absolute;
    top: 100%;
    left: 90%;
    transform: translateY(-50%);
    background-color: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 100;
    display: block;
  }

  .wishlist-container.hover {
    opacity: 1;
    pointer-events: all;
  }

  .add-wishlist {
    .icon {
      font-size: 24px;
    }
  }
  .modal-add{
      .custom-component {
        margin-top: 10px;
      }
      .input-wishlist{
        width: 100%;
        height: 28px;
        display: flex;
        -webkit-box-pack: justify;
        justify-content: space-between;
        -webkit-box-align: center;
        align-items: center;
        padding: 7px;
        box-sizing: border-box;
        border-radius: 6px;
        border: 1px solid rgb(204, 204, 204);
      }
      .btn-guardar {
        border: 1px solid var(--pink-contentoh);
        background: var(--pink-contentoh);
        color: var(--white-contentoh);
        border-radius: 30px;
        padding: 4px 8px;
        cursor: pointer;
        font-size: 12px;
        &:hover {
          border: 1px solid var(--pink-contentoh);
          background: var(--white-contentoh);
          color: var(--pink-contentoh);
        }
      }
      .btn-cancelar {
        border: 1px solid var(--pink-contentoh);
        background: var(--white-contentoh);
        color: var(--pink-contentoh);
        border-radius: 30px;
        cursor: pointer;
        padding: 4px 8px;
        &:hover {
          border: 1px solid var(--pink-contentoh);
          background: var(--pink-contentoh);
          color: var(--white-contentoh);
        }
      }
    }
`;
